export const tutorialsInitialState = {
  items: [],
  loading: false,
  error: null,
  lastFetchedAt: 0,
}
